
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import {
  computed,
  defineComponent,
  ref,
  toRefs,
} from 'vue';
import { BlogEntry } from '../models/Blog';
import getBlogImageSrc from '../utils/blogImage';

export default defineComponent({
  props: {
    entry: { type: Object as () => BlogEntry, required: true },
    type: {
      type: String,
      required: true
    },
    position: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const { entry } = toRefs(props);
    const { getFormattedTimeByAge } = useFormattedDateTime();
    const formattedDate = ref(getFormattedTimeByAge(props.entry.lastUpdated));
    const titleImageSrc = computed(() => getBlogImageSrc(entry.value.titleImage, entry.value.titleImageType));

    return { formattedDate, titleImageSrc };
  }
});
